import React from 'react';
import { cn } from './cn';
import { R, S } from './tokens';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  elevation?: 'default' | 'elevated' | 'flat';
  noPadding?: boolean;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ elevation = 'default', noPadding = false, className, children, ...rest }, ref) => {
    const shadow =
      elevation === 'elevated' ? S.md :
      elevation === 'flat'     ? undefined :
      S.sm;

    return (
      <div
        ref={ref}
        className={cn(
          'bg-white border border-slate-200 overflow-hidden',
          R.lg,
          shadow,
          !noPadding && 'p-6',
          className,
        )}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

Card.displayName = 'Card';
